import React, { useEffect } from "react";
import CustomRoutes from "../src/client/routes";
import { BrowserRouter } from "react-router-dom";
import Cookies from "universal-cookie";
import { API_SECRET_KEY, JWT_COOKIE_NAME } from "../src/client/constants";
import { BASE_URL } from "../src/store/urls";
import axios from "axios";
import { Provider } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";

// Config map
const appConfig = window.location.host == 'www.careers360.net'
  ? {
    REACT_APP_API_URL: 'https://api.careers360.net',
    REACT_APP_MAIN_LOGIN_URL: 'https://www.careers360.net',
    REACT_APP_SUB_DOMAIN_NAME: '.careers360.net',
    REACT_APP_SESSION_DOMAIN_NAME: '.careers360.net'
  }
  : {
    REACT_APP_API_URL: process.env.REACT_APP_API_URL,
    REACT_APP_MAIN_LOGIN_URL: process.env.REACT_APP_MAIN_LOGIN_URL,
    REACT_APP_SUB_DOMAIN_NAME: process.env.REACT_APP_SUB_DOMAIN_NAME,
    REACT_APP_SESSION_DOMAIN_NAME: process.env.REACT_APP_SESSION_DOMAIN_NAME,
  };

const cookies = new Cookies();
axios.defaults.baseURL = appConfig?.REACT_APP_API_URL;
axios.defaults.headers.common["x-api-key"] = API_SECRET_KEY;
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFToken";
// axios.defaults.timeout = 10000;

if (cookies.get(JWT_COOKIE_NAME + "_access")) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${cookies.get(
    JWT_COOKIE_NAME + "_access"
  )}`;
} else {
  axios.defaults.headers.common["Authorization"] = null;
}
axios.defaults.env.FormData = appConfig

export default function App({ store }) {
  useEffect(() => {
    // Set the previous path as the value of the current path.
    const prevPath = cookies.get("currentPath");
    if (prevPath != window?.location?.pathname) {
      cookies.set("prevPath", prevPath, { path: "/" });
      // Set the current path value by looking at the browser's location object.
      cookies.set("currentPath", window?.location?.pathname, { path: "/" });
    }
  }, []);
  
  return (
    <Provider store={store}>
      <BrowserRouter>
        <CustomRoutes location={window.location.pathname} />
      </BrowserRouter>
    </Provider>
  );
}